import { Box, Icon, Heading, Image, Link, Text } from '@redriverpress/system'

import HitWrapper from './HitWrapper'
import { getVideoLink } from '../../utils/hitLinks'
import { videoPropShape } from '../../constants/propShapes'

export default function VideoHit({ hit }) {
  const { image_url: imageUrl, slug, title, subtitle, category } = hit

  const { title: categoryTitle } = category

  return (
    <Link reset href={getVideoLink({ slug })}>
      <HitWrapper height='100%'>
        <Image
          display='block'
          src={imageUrl}
          alt={`Video image for ${title}`}
          width={1}
          borderTopLeftRadius='rounded'
          borderTopRightRadius='rounded'
          height={[108, null, null, 124]}
          style={{
            objectFit: 'cover',
          }}
          mb={2}
        />
        <Box p={[2, null, 3]}>
          <Heading as='h5' mb={1}>
            {title}
          </Heading>
          <Text fontSize={0}>{categoryTitle}</Text>
          {subtitle && (
            <Box
              display='flex'
              alignItems='baseline'
              my={3}
              mb={[2, null, 0]}
              mr={[0, null, 4]}
            >
              <Icon width='1rem' pr={2} flexShrink={0} icon='lightbulb' />
              <Text fontSize={0}>{subtitle}</Text>
            </Box>
          )}
        </Box>
      </HitWrapper>
    </Link>
  )
}

VideoHit.propTypes = {
  hit: videoPropShape.isRequired,
}
